import type { SupportModeSession } from "@/context/supportMode/supportModeSession";
import {
  readSupportModeSessionFromStorage,
  writeSupportModeSessionToStorage,
} from "@/store/supportModeSessionStorage";
import { create } from "zustand";

type SupportModeStore = {
  session: SupportModeSession | null;
  enterSupportMode: (session: SupportModeSession) => void;
  exitSupportMode: () => void;
};

export const useSupportModeStore = create<SupportModeStore>((set) => ({
  session: readSupportModeSessionFromStorage(),
  enterSupportMode: (session) => {
    writeSupportModeSessionToStorage(session);
    set({ session });
  },
  exitSupportMode: () => {
    writeSupportModeSessionToStorage(null);
    set({ session: null });
  },
}));

export const resetSupportModeStore = () => {
  useSupportModeStore.getState().exitSupportMode();
};
